export const API_LOADING = 'loading'
export const API_COMPLETED = 'completed'
export const API_ERROR = 'error'



